// Polyfills for Node.js globals in browser environment
if (typeof global === 'undefined') {
  window.global = window;
}

if (typeof process === 'undefined') {
  window.process = {
    env: {},
    browser: true,
    version: 'v16.0.0',
    platform: 'browser',
    nextTick: (fn) => setTimeout(fn, 0),
  };
}
